import "./Home.css"; // Custom CSS file for styling
import React from 'react';

const CustomGoogleReviewSection = () => {
  // Dummy review data
  const reviews = [
    {
      text: "Incorporating my company in Wyoming was a big step, but Bookscomply.com made the entire process smooth and stress-free. They handled everything from paperwork to compliance, so I could focus on growing my business. Highly recommended!",
      author_name: <div>Chirag Darji<br /><span className="company-name">Variance Infotech LLC</span></div>,
      rating: 5,
      source: "Google",
    },
    {
      text: "NJP Global Team has been very good for Company incorporation in the USA and afterwards compliance. We set up our company incorporation through them.Their whole team is so kind and co-operative. They are very prompt in response. Highly Recommended.",
      author_name: <div><span className="company-name">Tektrois Inc</span></div>,
      rating: 5,
      source: "Google",
    },
    {
      text: "We set our company in Wyoming (USA) from NJP Global. There prices are very reasonable from other consulting firms. Very supportive and Highly recommended. I personally suggest if you are looking for company incorporation and afterwards compliance like USA Tax return and Annual tax report.",
      author_name: <div>Manan Panchal<br /><span className="company-name">Marga Consulting LLC</span></div>,
      rating: 5,
      source: "Google",
    },
  ];

  return (
    <div className="custom-review-container">
      <div className="container py-5">
        <h2 className="text-center mb-4">What Our Customers Say</h2>
        <div className="row">
          {reviews.map((review, index) => (
            <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={index}>
              <div className="card shadow h-100">
                <div className="card-body">
                  <p className="card-text">"{review.text}"</p>
                  <div className="mt-3 d-flex align-items-center">
                    <div>
                      <h5 className="card-title mb-0">{review.author_name}</h5>
                    </div>
                  </div>
                  <div className="mt-2">
                    {Array(review.rating)
                      .fill()
                      .map((_, i) => (
                        <span key={i} className="text-warning">&#9733;</span>
                      ))}
                  </div>
                </div>
              </div>
            </div>  
          ))}
        </div>
      </div>
    </div>
  );
};

export default CustomGoogleReviewSection;